<template>
  <hm-content title="排班列表" class="scheduling">
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" plain size="small" @click="toAddScheduling"
          >新增排班</el-button
        >
      </div>
      <div>
        <el-select
          v-model="storeOutletId"
          placeholder="选择门店"
          size="small"
          class="mr10"
          filterable
          clearable
        >
          <el-option
            v-for="item in storeList.list"
            :key="item.value"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          clearable
          v-model="serverId"
          placeholder="选择服务"
          size="small"
          filterable
          class="mr10"
        >
          <el-option
            v-for="item in serviceList.list"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-input
          clearable
          v-model.trim="keyWord"
          placeholder="输入姓名/工号/手机号"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button
          type="primary"
          size="small"
          @click="search"
          placeholder="输入名称"
          >查询</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        :data="schedulingList.list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          width="50"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="guiderName"
          label="技师"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="storeOutlet"
          label="分配服务"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="showRules(scope.row.ruleList)"
              >{{ scope.row.serverNameList.join(",") }}</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="storeOutlet"
          label="归属门店"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="guiderName"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="edit(scope.row)"
              >编辑</el-button
            >
            <el-button type="text" size="small" @click="remove(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="schedulingList.total"
        @current-change="paging"
        layout="total,sizes,   prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      title="新增排班"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
      @close="resetForm('ruleForm')"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="选择门店：" prop="store">
          <el-select
            v-model="ruleForm.storeOutletId"
            placeholder="选择门店"
            size="small"
            filterable
            :disabled="mode === 'edit'"
            @change="selectStore"
          >
            <el-option
              v-for="item in storeList.list"
              :key="item.value"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择技师：" prop="storeUserId">
          <el-select
            :disabled="!ruleForm.storeOutletId || mode === 'edit'"
            v-model="ruleForm.storeUserId"
            placeholder="选择技师"
            size="small"
            @change="selectGuider"
            filterable
          >
            <el-option
              v-for="(item, i) in staffList.list"
              :key="i"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分配服务：" prop="serverId">
          <el-select
            :disabled="!ruleForm.storeUserId"
            placeholder="选择服务"
            v-model="ruleForm.serverId"
            size="small"
            filterable
            class="mr10"
          >
            <el-option
              v-for="(item, index) in guiderServiceList"
              :key="index"
              :label="item.name"
              :value="item.id"
              :disabled="!ruleForm.storeUserId"
            ></el-option>
          </el-select>
          <el-button
            size="small"
            type="primary"
            @click="assign"
            :disabled="!ruleForm.serverId"
            >添加对应排班</el-button
          >
          <el-button
            size="small"
            type="primary"
            :disabled="!ruleForm.serverId"
            @click="deleteScheduling"
            >删除对应排班</el-button
          >
        </el-form-item>
        <ul class="detail-list" v-show="assignedList.length">
          <li
            v-for="(v, i) in assignedList"
            :key="i"
            class="detail-list-item flex"
          >
            <div class="service-name flex item-center">{{ v.name }}</div>
            <div class="config">
              <div class="day flex item-center">
                <div>配置日期：</div>
                <div>
                  <el-select
                    size="small"
                    v-model="v.selectedDays"
                    multiple
                    class=" multiple-select"
                    placeholder="请选择日期（可多选）"
                    style="width: 426px"
                  >
                    <el-option
                      v-for="(item, index) in v.days"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="time flex item-center">
                <div class="select-time-range flex item-center">选择时段：</div>
                <dl class="time-list">
                  <dt class="flex list-header">
                    <span class="time-range">开始时间</span>
                    <span class="limit">被预约最大人数</span>
                  </dt>
                  <dt class="flex item-center controls">
                    <div class="time-range">
                      <el-time-picker
                        is-range
                        v-model="timeRange"
                        range-separator="至"
                        size="small"
                        format="HH:mm"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        placeholder="选择时间范围"
                      ></el-time-picker>
                    </div>
                    <div class="limit">
                      <el-input
                        size="small"
                        type="number"
                        style="width: 120px; text-align: center"
                        v-model.trim="limit"
                        min="1"
                        clearable
                        placeholder="最大人数"
                        @keyup.enter.native="handleLogin"
                      ></el-input>
                    </div>
                    <div class="opreat">
                      <el-button
                        type="primary"
                        @click="addTimeAndLimit(i)"
                        size="mini"
                        icon="hmicon icon-hao"
                        circle
                      ></el-button>
                    </div>
                  </dt>
                  <dd
                    v-for="(item, index) in v.timeAndLimitList"
                    :key="index"
                    class="flex item-center time-list-item"
                  >
                    <span class="time-range"
                      >{{ item.startTime }}&nbsp;&nbsp;至&nbsp;&nbsp;{{
                        item.endTime
                      }}</span
                    >
                    <span class="limit">{{ item.limit }}</span>
                    <div class="opreat">
                      <el-button
                        type="warning"
                        @click="deleteCurrentLimit(i, index)"
                        size="mini"
                        icon="hmicon icon-jianhao"
                        circle
                      ></el-button>
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </li>
        </ul>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitForm('ruleForm')"
            >提交</el-button
          >
          <el-button size="small" @click="resetForm('ruleForm')"
            >返回</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      title="服务分配列表"
      :close-on-click-modal="false"
      :visible.sync="dialogServiceVisible"
      @close="clear"
    >
      <ul class="detail-list">
        <li
          v-for="(v, i) in currentServiceList"
          :key="i"
          class="detail-list-item flex"
        >
          <div class="service-name flex item-center">{{ v.name }}</div>
          <div class="config">
            <div class="day flex item-center">
              <div>配置日期：</div>
              <div>
                <span
                  v-for="(item, index) in v.selectedDaysFormat"
                  :key="index"
                  class="mr10"
                  >{{ item.name }}</span
                >
              </div>
            </div>
            <div class="time flex item-center">
              <div class="select-time-range flex item-center">选择时段：</div>
              <dl class="time-list">
                <dt class="flex list-header">
                  <span class="time-range">开始时间</span>
                  <span class="limit">被预约最大人数</span>
                </dt>
                <dd
                  v-for="(item, index) in v.timeAndLimitList"
                  :key="index"
                  class="flex item-center time-list-item"
                >
                  <span class="time-range"
                    >{{ item.startTime }}&nbsp;&nbsp;至&nbsp;&nbsp;{{
                      item.endTime
                    }}</span
                  >
                  <span class="limit">{{ item.limit }}</span>
                </dd>
              </dl>
            </div>
          </div>
        </li>
      </ul>
      <div class="flex flex-center">
        <el-button size="small" @click="clear">返回</el-button>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
 import moment from "moment";
import { mapGetters } from "vuex";
export default {
    
  data() {
    const patternSelectedServerList = function(rule, val, callback) {
      if (!this.ruleForm.serverId) {
        return callback(new Error("请分配服务"));
      }
      this.assignedList.forEach(v => {
        if (v.selectedDays.length && v.timeAndLimitList.length) {
          callback();
        } else if (!v.selectedDays.length) {
          return callback(new Error("请配置日期"));
        } else if (!v.timeAndLimitList.length) {
          return callback(new Error("请选择时段"));
        }
      });
    }.bind(this);
    return {
      storeOutletId: "",
      currentPage: 1,
      pageSize: 10,
      serverId: "",
      keyWord: "",
      mode: "",
      currentServiceList: [],
      dateAndTime: [],
      assignedList: [],
      guiderServiceList: [],
      timeRange: [new Date(2016, 9, 10, 8, 0), new Date(2016, 9, 10, 9, 0)],
      startTime: "",
      endTime: "",
      limit: 1,
      days: [
        { id: 1, name: "周一" },
        { id: 2, name: "周二" },
        { id: 3, name: "周三" },
        { id: 4, name: "周四" },
        { id: 5, name: "周五" },
        { id: 6, name: "周六" },
        { id: 7, name: "周日" }
      ],
      dialogFormVisible: false,
      dialogServiceVisible: false,
      ruleForm: {
        serverId: "",
        storeOutletId: "",
        storeUserId: ""
      },
      rules: {
        storeOutletId: {
          required: true,
          message: "请选择门店",
          trigger: "change"
        },
        storeUserId: {
          required: true,
          message: "请选择技师",
          trigger: "change"
        },
        serverId: {
          required: true,
          trigger: "blur",
          validator: patternSelectedServerList
        }
      }
    };
  },
  mounted() {
    this.queryList();
    this.$store.dispatch("queryServiceList", { pageSize: 999 });
    this.$store.dispatch("queryStoreList", { pageSize: 999 });
  },
  computed: mapGetters([
    "schedulingList",
    "storeList",
    "serviceList",
    "staffList"
  ]),
  watch: {},
  methods: {
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    queryList() {
      this.$store.dispatch("querySchedulingList", {
        keyWord: this.keyWord,
        serverId: this.serverId,
        storeOutletId: this.storeOutletId
      });
    },
    search() {
      this.queryList();
    },
    toAddScheduling() {
      // this.mode = "add";
      // this.dialogFormVisible = true;
      this.$router.push({ name: "AddScheduling" });
    },
    showRules(list) {
      this.dialogServiceVisible = true;
      this.strToObj({ list, needFormatArr: "currentServiceList" });
    },
    strToObj({ list, needFormatArr }) {
      list.forEach((v, i) => {
        const startDateList = v.startDate.split(",");
        const endDateList = v.endDate.split(",");
        const limitList = v.maxValue.split(",");
        const weekList = v.week.split(",");
        this[needFormatArr].push({
          selectedDays: [],
          selectedDaysFormat: [],
          id: v.serverId,
          ruleId: v.id,
          name: v.serverName,
          timeAndLimitList: []
        });
        startDateList.forEach((item, index) => {
          this[needFormatArr][i].timeAndLimitList.push({
            startTime: item,
            endTime: endDateList[index],
            limit: Number(limitList[index])
          });
        });
        weekList.forEach(item => {
          const { id, name } = this.days.find(
            value => value.id === Number(item)
          );
          this[needFormatArr][i].days = this.days;
          this[needFormatArr][i].selectedDays.push(id);
          this[needFormatArr][i].selectedDaysFormat.push({ id, name });
        });
        if (!this.mode) {
          this[needFormatArr][i].selectedDays.sort((a, b) => a - b);
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = {
            ruleList: [],
            storeOutletId: this.ruleForm.storeOutletId,
            storeUserId: this.ruleForm.storeUserId
          };
          this.assignedList.forEach(v => {
            let serverId = [];
            let week = v.selectedDays;
            let startDate = [];
            let endDate = [];
            let maxValue = [];
            serverId.push(v.id);
            v.timeAndLimitList.forEach(item => {
              startDate.push(item.startTime);
              endDate.push(item.endTime);
              maxValue.push(item.limit);
            });
            params.ruleList.push({
              id: v.ruleId,
              week: week.join(","),
              startDate: startDate.join(","),
              endDate: endDate.join(","),
              maxValue: maxValue.join(","),
              serverId: serverId.join(",")
            });
          });
          let actionName;
          if (this.mode === "add") {
            actionName = "addScheduling";
          } else if (this.mode === "edit") {
            actionName = "editScheduling";
            params = Object.assign(params, { id: this.currentRowId });
          }
          this.$store.dispatch(actionName, params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功！",
                type: "success"
              });
              this.resetForm(formName);
              this.queryList();
            }
          });
        } else {
          return false;
        }
      });
    },
    edit(row) {
      this.$router.push({ name: "EditScheduling", id: row.id });
      this.currentRowId = row.id;
      // this.dialogFormVisible = true;
      // this.mode = "edit";
      // this.$store.dispatch("queryStoreList", { pageSize: 999 });
      // this.ruleForm.storeOutletId = row.storeOutletId;
      // this.guiderServiceList = [];
      // this.$store
      //   .dispatch("queryStaffList", {
      //     pageSize: 999,
      //     storeOutletId: row.storeOutletId
      //   })
      //   .then(res => {
      //     if (res.code === "0") {
      //       this.ruleForm.storeUserId = row.storeUserId;
      //       res.result.list.forEach(v => {
      //         if (v.id === row.storeUserId) {
      //           const serverIdList = v.serverId.split(",");
      //           const serverNameList = v.serverName.split(",");
      //           serverIdList.forEach((item, i) => {
      //             this.guiderServiceList.push({
      //               name: serverNameList[i],
      //               id: Number(item)
      //             });
      //           });
      //         }
      //       });
      //       this.ruleForm.serverId = this.guiderServiceList[
      //         this.guiderServiceList.length - 1
      //       ].id;
      //       this.strToObj({
      //         list: row.ruleList,
      //         needFormatArr: "assignedList"
      //       });
      //     }
      //   });
    },
    remove(id) {
      this.$confirm("删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store.dispatch("deleteScheduling", { id }).then(res => {
          if (res.code === "0") {
            this.$message({
              message: "删除排班成功！",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      for (let key in this.ruleForm) {
        this.ruleForm[key] = "";
      }
      this.assignedList = [];
      this.dialogFormVisible = false;
    },
    selectStore(e) {
      this.assignedList = [];
      this.$store.commit("RESET_STAFF_LIST");
      this.ruleForm.storeUserId = "";
      this.$store.dispatch("queryStaffList", {
        pageSize: 999,
        storeOutletId: e
      });
    },
    selectService(e) {
      e.forEach(v => {
        this.assignedList.push({
          id: v,
          name: this.guiderServiceList.find(
            v => v.id === this.ruleForm.serverId
          ),
          days: this.days,
          selectedDays: [],
          timeAndLimitList: []
        });
      });
    },
    selectGuider() {
      const { serverId, serverName } = this.staffList.list.find(
        v => v.id === this.ruleForm.storeUserId
      );
      this.ruleForm.serverId = "";
      this.guiderServiceList = [];
      this.assignedList = [];
      serverId.split(",").forEach((v, i) => {
        this.guiderServiceList.push({
          name: serverName.split(",")[i],
          id: v
        });
      });
    },
    // 添加排班
    assign() {
      // 检察是否已提交
      const isCommon = this.assignedList.findIndex(
        v => v.id === this.ruleForm.serverId
      );
      if (isCommon > -1) {
        this.$message.error("不要重复添加服务对应排班！");
      } else {
        const { name } = this.guiderServiceList.find(
          v => v.id === this.ruleForm.serverId
        );
        this.assignedList.push({
          id: this.ruleForm.serverId,
          name,
          days: this.days,
          selectedDays: [],
          timeAndLimitList: []
        });
      }
    },
    clear() {
      this.dialogServiceVisible = false;
      this.currentServiceList = [];
    },
    // 删除排班
    deleteScheduling() {
      const index = this.assignedList.findIndex(
        v => v.id === this.ruleForm.serverId
      );
      if (index > -1) {
        this.assignedList.splice(index, 1);
      }
    },
    addTimeAndLimit(fatherIndex) {
      const limit = this.limit <= 0 ? 1 : Math.floor(this.limit);
      if (this.timeRange) {
        const startTime = moment(this.timeRange[0]).format("HH:mm");
        const endTime = moment(this.timeRange[1]).format("HH:mm");
        const currentTimeList = this.assignedList[fatherIndex].timeAndLimitList;
        const currentTimeListLen = this.assignedList[fatherIndex]
          .timeAndLimitList.length;
        // 开始时间小于结束时间
        if (startTime < endTime) {
          if (currentTimeListLen) {
            // 当前时间段的结束时间应小于已选时间段的开始时间或
            // 当前时间段的开始时间大于已选时间段的结束时间
            // 当前时间段的等于已选时间段
            const isCommon = currentTimeList.filter(v => {
              return (
                (startTime > v.startTime && startTime < v.endTime) ||
                (endTime > v.startTime && endTime < v.endTime) ||
                (startTime === v.startTime && endTime === v.endTime) ||
                (startTime <= v.startTime && endTime >= v.endTime)
              );
            }).length;
            if (isCommon) {
              this.$message.error("添加时间应大于或小于已选时间段");
            } else {
              this.assignedList[fatherIndex].timeAndLimitList.push({
                startTime,
                endTime,
                limit
              });
            }
          } else {
            this.assignedList[fatherIndex].timeAndLimitList.push({
              startTime,
              endTime,
              limit
            });
          }
        } else {
          this.$message.error("开始时间应小于结束时间");
        }
      }
    },
    deleteCurrentLimit(fatherIndex, index) {
      this.assignedList[fatherIndex].timeAndLimitList.splice(index, 1);
    }
  }
};
</script>

<style scoped lang="scss">
$borderColor: #ebebeb;
.detail-list {
  border: 1px solid $borderColor;
  margin-bottom: 10px;
  .time-list {
    flex: 1;
    .hmicon {
      font-size: 20px;
    }
    .list-header {
      padding: 12px;
      border-bottom: 1px solid $borderColor;
      .limit {
        margin-right: 8%;
      }
    }
    .controls {
      padding: 12px;
    }
    .time-list-item {
      border-top: 1px solid $borderColor;
      padding: 12px;
      overflow: hidden;
    }
    .time-range,
    .limit,
    .opreate {
      text-align: center;
      margin: 0 10px;
    }
    .time-range {
      width: 60%;
    }
    .limit {
      width: 30%;
    }
    .opreate {
      width: 10%;
    }
  }
  .detail-list-item:not(:last-child) {
    border-bottom: 1px solid $borderColor;
  }
  .service-name {
    border-right: 1px solid $borderColor;
    padding: 12px;
    background: #f5f7fa;
  }
  .config {
    flex: 1;
    -webkit-flex: 1;
    .day {
      padding: 12px;
      border-bottom: 1px solid $borderColor;
    }
    .time {
      height: calc(100% - 44px);
    }
    .select-time-range {
      vertical-align: middle;
      height: 100%;
      padding: 12px;
      border-right: 1px solid $borderColor;
      box-sizing: border-box;
    }
  }
}
</style>
